<div class="flex flex-col gap-6">
  <!-- 1. EN-TÊTE RÉCAPITULATIF & JAUGE DES PLACES -->
  <div
    class="flex flex-col lg:flex-row lg:items-center justify-between gap-6 p-6 rounded-2xl border border-neutral-4 bg-white shadow-xs"
  >
    <div class="flex flex-col gap-1.5">
      <div class="flex items-center gap-2.5">
        <div
          class="flex size-9 items-center justify-center rounded-xl bg-indigo-2 text-indigo-11 border border-indigo-4"
        >
          <mat-icon class="size-5 text-lg!">groups</mat-icon>
        </div>
        <h2 class="text-xl font-bold text-neutral-12 m-0">Candidatures reçues sur votre bien</h2>
      </div>
      <p class="text-xs sm:text-sm text-neutral-10 m-0 max-w-2xl leading-relaxed">
        Jusqu'à 5 agents certifiés peuvent se positionner simultanément sur votre bien. Comparez leurs
        engagements, observez leurs visites et attribuez votre mandat en toute sérénité.
      </p>
    </div>

    <!-- JAUGE DE PLACES, BADGES & MARCHÉ DVF -->
    <div class="flex flex-wrap items-center gap-3 self-start lg:self-center justify-end">
      <!-- Repère marché DVF du secteur -->
      @if (dvfData(); as dvf) {
        @if (dvf.medianPriceM2) {
          <div
            class="flex items-center gap-3 p-3 rounded-xl bg-neutral-2 border border-neutral-4"
            matTooltip="Médiane des prix de vente réels constatés par les notaires (DGFiP) pour ce type de bien dans votre quartier"
          >
            <div
              class="flex size-9 items-center justify-center rounded-lg bg-indigo-2 text-indigo-11 border border-indigo-4 shrink-0"
            >
              <mat-icon class="size-5 text-lg!">analytics</mat-icon>
            </div>
            <div class="flex flex-col">
              <span class="text-[11px] font-semibold text-neutral-10 uppercase tracking-wider">
                Marché DVF quartier
              </span>
              <div class="flex items-baseline gap-1 mt-0.5">
                <span class="text-xl font-black text-neutral-12">
                  {{ dvf.medianPriceM2 | number: '1.0-0' : 'fr-FR' }} €
                </span>
                <span class="text-xs font-semibold text-neutral-9">/ m²</span>
              </div>
            </div>
          </div>
        }
      }

      <!-- Jauge de places attribuées -->
      <div class="flex items-center gap-3 p-3 rounded-xl bg-neutral-2 border border-neutral-4">
        <div class="flex flex-col">
          <span class="text-[11px] font-semibold text-neutral-10 uppercase tracking-wider">
            Places attribuées
          </span>
          <div class="flex items-baseline gap-1 mt-0.5">
            <span class="text-2xl font-black text-neutral-12">{{ acceptedApplicationsCount() }}</span>
            <span class="text-xs font-semibold text-neutral-9">/ {{ MAX_SLOTS }} agents max</span>
          </div>
        </div>

        <div class="h-8 w-px bg-neutral-4 mx-1"></div>

        <!-- Badge statut global -->
        @if (acceptedApplication()) {
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-jade-2 text-jade-11 border border-jade-5"
          >
            <mat-icon class="size-4 text-base! text-jade-11">handshake</mat-icon>
            <span>Mandat attribué</span>
          </span>
        } @else if (remainingSlotsCount() === 0) {
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-indigo-2 text-indigo-11 border border-indigo-5"
          >
            <mat-icon class="size-4 text-base! text-indigo-11">lock</mat-icon>
            <span>Complet (5/5 agents)</span>
          </span>
        } @else {
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-jade-2 text-jade-11 border border-jade-5"
          >
            <mat-icon class="size-4 text-base! text-jade-11">radio_button_checked</mat-icon>
            <span
              >{{ remainingSlotsCount() }} place{{ remainingSlotsCount() > 1 ? 's' : '' }} libre{{
                remainingSlotsCount() > 1 ? 's' : ''
              }}</span
            >
          </span>
        }

        @if (cancelledApplicationsCount() > 0) {
          <div class="h-8 w-px bg-neutral-4 mx-1"></div>
          <button
            type="button"
            (click)="setFilter(filterTab() === 'cancelled' ? 'active' : 'cancelled')"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors cursor-pointer border"
            [class]="
              filterTab() === 'cancelled'
                ? 'bg-red-3 text-red-11 border-red-5'
                : 'bg-neutral-2 hover:bg-neutral-3 text-neutral-11 border-neutral-4'
            "
            matTooltip="Afficher les candidatures retirées ou clôturées"
          >
            <mat-icon class="size-4 text-base! text-red-9">cancel</mat-icon>
            <span
              >{{ cancelledApplicationsCount() }} annulée{{
                cancelledApplicationsCount() > 1 ? 's' : ''
              }}</span
            >
          </button>
        }
      </div>
    </div>
  </div>

  <!-- 2. SQUELETTE DE CHARGEMENT -->
  @if (isLoading()) {
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      @for (i of [1, 2, 3, 4]; track i) {
        <div
          class="h-96 rounded-2xl border border-neutral-3 bg-neutral-2/50 animate-pulse p-6 flex flex-col gap-4"
        >
          <div class="flex items-center justify-between">
            <div class="h-5 w-28 bg-neutral-4 rounded-md"></div>
            <div class="h-4 w-20 bg-neutral-4 rounded"></div>
          </div>
          <div class="flex items-center gap-4 pt-2">
            <div class="size-14 rounded-2xl bg-neutral-4"></div>
            <div class="flex-1 flex flex-col gap-2">
              <div class="h-5 w-44 bg-neutral-4 rounded"></div>
              <div class="h-4 w-32 bg-neutral-4 rounded"></div>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3 mt-2">
            <div class="h-20 bg-neutral-4/70 rounded-xl"></div>
            <div class="h-20 bg-neutral-4/70 rounded-xl"></div>
          </div>
          <div class="h-10 w-full bg-neutral-4 rounded-lg mt-auto"></div>
        </div>
      }
    </div>
  } @else {
    <!-- BARRE D'ONGLETS / FILTRES (visible si des candidatures sont annulées) -->
    @if (cancelledApplicationsCount() > 0) {
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center p-1 rounded-xl bg-neutral-2 border border-neutral-4">
          <button
            type="button"
            (click)="setFilter('active')"
            class="flex items-center gap-2 px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-all cursor-pointer"
            [class]="
              filterTab() === 'active'
                ? 'bg-white text-neutral-12 shadow-xs border border-neutral-4'
                : 'text-neutral-10 hover:text-neutral-12'
            "
          >
            <mat-icon
              class="size-4 text-base!"
              [class]="filterTab() === 'active' ? 'text-indigo-11' : 'text-neutral-9'"
            >
              groups
            </mat-icon>
            <span>En cours</span>
            <span
              class="inline-flex items-center px-1.5 py-0.2 rounded-md text-[10px] font-bold"
              [class]="
                filterTab() === 'active' ? 'bg-indigo-3 text-indigo-11' : 'bg-neutral-4 text-neutral-10'
              "
            >
              {{ activeApplicationsCount() }}
            </span>
          </button>

          <button
            type="button"
            (click)="setFilter('cancelled')"
            class="flex items-center gap-2 px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-all cursor-pointer"
            [class]="
              filterTab() === 'cancelled'
                ? 'bg-white text-neutral-12 shadow-xs border border-neutral-4'
                : 'text-neutral-10 hover:text-neutral-12'
            "
          >
            <mat-icon
              class="size-4 text-base!"
              [class]="filterTab() === 'cancelled' ? 'text-red-9' : 'text-neutral-9'"
            >
              cancel
            </mat-icon>
            <span>Annulées ou retirées</span>
            <span
              class="inline-flex items-center px-1.5 py-0.2 rounded-md text-[10px] font-bold"
              [class]="filterTab() === 'cancelled' ? 'bg-red-3 text-red-11' : 'bg-neutral-4 text-neutral-10'"
            >
              {{ cancelledApplicationsCount() }}
            </span>
          </button>

          <button
            type="button"
            (click)="setFilter('all')"
            class="flex items-center gap-2 px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-all cursor-pointer"
            [class]="
              filterTab() === 'all'
                ? 'bg-white text-neutral-12 shadow-xs border border-neutral-4'
                : 'text-neutral-10 hover:text-neutral-12'
            "
          >
            <span>Toutes</span>
            <span
              class="inline-flex items-center px-1.5 py-0.2 rounded-md text-[10px] font-bold"
              [class]="
                filterTab() === 'all' ? 'bg-neutral-4 text-neutral-12' : 'bg-neutral-4 text-neutral-10'
              "
            >
              {{ applications().length }}
            </span>
          </button>
        </div>

        <span class="text-xs text-neutral-10 hidden sm:inline">
          @if (filterTab() === 'active') {
            Affichage des {{ activeApplicationsCount() }} candidature{{
              activeApplicationsCount() > 1 ? 's' : ''
            }}
            en compétition active
          } @else if (filterTab() === 'cancelled') {
            Affichage des {{ cancelledApplicationsCount() }} candidature{{
              cancelledApplicationsCount() > 1 ? 's' : ''
            }}
            clôturée{{ cancelledApplicationsCount() > 1 ? 's' : '' }} ou retirée{{
              cancelledApplicationsCount() > 1 ? 's' : ''
            }}
          } @else {
            Toutes les candidatures reçues sur votre bien
          }
        </span>
      </div>
    }

    <!-- ALERTE SI AUCUNE CANDIDATURE ACTIVE MAIS CANDIDATURES ANNULÉES EXISTANTES -->
    @if (activeApplicationsCount() === 0 && cancelledApplicationsCount() > 0 && filterTab() === 'active') {
      <div
        class="flex items-center justify-between gap-3 p-4 rounded-xl border border-amber-4 bg-amber-2/50 text-amber-12 text-xs"
      >
        <div class="flex items-center gap-2.5">
          <mat-icon class="size-5 text-lg! text-amber-10 shrink-0">info</mat-icon>
          <span>
            Aucune candidature n'est active actuellement. {{ cancelledApplicationsCount() }} candidature{{
              cancelledApplicationsCount() > 1
                ? 's ont été retirées ou annulées'
                : ' a été retirée ou annulée'
            }}.
          </span>
        </div>
        <button
          type="button"
          (click)="setFilter('cancelled')"
          class="font-bold text-amber-11 hover:underline cursor-pointer flex items-center gap-1 shrink-0"
        >
          <span>Consulter les retraits</span>
          <mat-icon class="size-3.5 text-sm!">arrow_forward</mat-icon>
        </button>
      </div>
    }

    <!-- 1. VUE DES CANDIDATURES EN COURS (OU TOUTES) -->
    @if (filterTab() === 'active' || filterTab() === 'all') {
      @if (filterTab() === 'all' && cancelledApplicationsCount() > 0) {
        <div class="flex items-center gap-2 pt-2 border-t border-neutral-3">
          <h3 class="text-xs font-bold text-neutral-11 m-0 uppercase tracking-wider">
            Candidatures en cours ({{ activeApplicationsCount() }} / {{ MAX_SLOTS }})
          </h3>
        </div>
      }

      <!-- 3. GRILLE DES PLACES (2 COLONNES) -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 items-stretch">
        @for (slot of slots(); track slot.index) {
          @if (slot.application; as app) {
            @let statusConfig = getStatusConfig(app.status);
            <!-- CARTE D'UN AGENT CANDIDAT -->
            <div
              class="group relative flex flex-col justify-between rounded-2xl border bg-white p-5 sm:p-6 shadow-xs transition-all duration-200 hover:shadow-md hover:border-indigo-6 cursor-pointer"
              [class]="
                app.status === 'accepted'
                  ? 'border-jade-6 ring-1 ring-jade-6/40 bg-jade-1/20'
                  : 'border-neutral-4'
              "
              (click)="onSelect(app)"
              tabindex="0"
              (keydown.enter)="onSelect(app)"
              (keydown.space)="onSelect(app)"
              role="button"
              [attr.aria-label]="'Consulter la candidature de ' + getAgentName(app)"
            >
              <div>
                <!-- En-tête de carte : Place, Statut & Date -->
                <div class="flex items-center justify-between gap-3 mb-4">
                  <div class="flex items-center gap-2 flex-wrap">
                    <!-- Badge statut d'avancement -->
                    <span
                      class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md text-xs font-semibold border"
                      [class]="statusConfig.badgeClass"
                    >
                      <mat-icon class="size-3.5 text-[13px]!">{{ statusConfig.icon }}</mat-icon>
                      <span>{{ statusConfig.label }}</span>
                    </span>
                    @if (app.status === 'accepted') {
                      <span
                        class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-bold bg-jade-3 text-jade-12 border border-jade-6"
                      >
                        <mat-icon class="size-3.5 text-[13px]!">handshake</mat-icon>
                        <span>Mandataire sélectionné</span>
                      </span>
                    }
                  </div>

                  @if (app.createdAt) {
                    <span class="text-[11px] text-neutral-9 shrink-0 flex items-center gap-1">
                      <mat-icon class="size-3 text-[11px]! text-neutral-8">schedule</mat-icon>
                      <span>{{ app.createdAt | luxonDate: 'humanize' }}</span>
                    </span>
                  }
                </div>

                <!-- PROFIL AGENT -->
                <div class="flex items-start justify-between gap-4 pb-4 border-b border-neutral-3">
                  <div class="flex items-start gap-3.5 min-w-0">
                    <!-- Avatar -->
                    <button
                      type="button"
                      (click)="openAgentProfileModal(app, $event)"
                      class="relative size-14 shrink-0 rounded-2xl overflow-hidden bg-indigo-2 text-indigo-11 border border-indigo-4 flex items-center justify-center font-bold text-base shadow-2xs hover:ring-2 hover:ring-indigo-6 hover:scale-105 transition-all cursor-pointer p-0"
                      matTooltip="Voir le profil professionnel de l'agent"
                    >
                      @if (getAgentAvatar(app); as avatarUrl) {
                        <img [src]="avatarUrl" [alt]="getAgentName(app)" class="h-full w-full object-cover" />
                      } @else {
                        <span>{{ getAgentInitials(app) }}</span>
                      }
                    </button>

                    <!-- Nom & Réseau & Ville -->
                    <div class="flex flex-col min-w-0">
                      <button
                        type="button"
                        (click)="openAgentProfileModal(app, $event)"
                        class="group/agent text-left p-0 border-0 bg-transparent cursor-pointer flex items-center gap-1.5 min-w-0"
                        matTooltip="Voir le profil professionnel de l'agent"
                      >
                        <span
                          class="font-bold text-base text-neutral-12 truncate leading-tight group-hover/agent:text-primary transition-colors"
                        >
                          {{ getAgentName(app) }}
                        </span>
                        <mat-icon
                          class="size-3.5 text-sm! text-neutral-8 group-hover/agent:text-primary transition-colors shrink-0"
                          >open_in_new</mat-icon
                        >
                      </button>

                      @let aff = getAgentAffiliation(app);
                      <div class="flex items-center gap-1.5 mt-1 text-xs text-neutral-11 flex-wrap">
                        <span
                          class="inline-flex items-center gap-1 px-2 py-0.5 rounded font-semibold text-[11px] border"
                          [class]="
                            aff.isTitulaire
                              ? 'bg-amber-1 text-amber-12 border-amber-4'
                              : 'bg-indigo-1 text-indigo-12 border-indigo-4'
                          "
                        >
                          <mat-icon class="size-3.5 text-[13px]! text-neutral-10">
                            {{ aff.isTitulaire ? 'badge' : aff.agencyName ? 'corporate_fare' : 'hub' }}
                          </mat-icon>
                          <span>{{ aff.displayBadge }}</span>
                        </span>

                        <span class="text-[10px] text-neutral-9 font-medium">
                          {{ aff.typeLabel }}
                        </span>

                        @if (getAgentCity(app); as city) {
                          <span class="text-neutral-7">•</span>
                          <span class="flex items-center gap-0.5 text-neutral-10 text-xs">
                            <mat-icon class="size-3 text-[11px]! text-neutral-8">place</mat-icon>
                            <span>{{ city }}</span>
                          </span>
                        }
                      </div>
                    </div>
                  </div>

                  <!-- Bouton Message rapide -->
                  <button
                    mat-stroked-button
                    class="h-8! px-2.5! text-xs! font-medium! shrink-0 flex items-center gap-1 text-neutral-11 hover:text-primary"
                    (click)="openDiscussion(app, $event)"
                    type="button"
                    matTooltip="Échanger par messagerie avec cet agent"
                  >
                    <mat-icon class="size-3.5 text-[14px]!">chat</mat-icon>
                    <span class="hidden sm:inline">Message</span>
                  </button>
                </div>

                <!-- SECTION CHIFFRES CLÉS / ENGAGEMENT (2 BLOCS) -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 my-4">
                  <!-- 1. Honoraires proposés -->
                  <div
                    class="p-3.5 rounded-xl bg-neutral-2/60 border border-neutral-3 flex flex-col justify-between gap-1"
                  >
                    <div class="flex items-center justify-between">
                      <span class="text-[11px] font-semibold text-neutral-10">Honoraires proposés</span>
                      @if (hasFinalOffer(app)) {
                        <span
                          class="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-purple-2 text-purple-11 border border-purple-4"
                        >
                          Offre définitive
                        </span>
                      } @else {
                        <span
                          class="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-neutral-3 text-neutral-10"
                        >
                          Taux initial
                        </span>
                      }
                    </div>

                    <div class="flex items-baseline gap-1.5 mt-1">
                      <span class="text-xl font-black text-neutral-12"> {{ getCommissionRate(app) }} % </span>
                      @if (getCommissionEuros(app); as comm) {
                        <span class="text-xs text-neutral-10 font-medium">
                          (env. {{ comm | number: '1.0-0' : 'fr-FR' }} €)
                        </span>
                      }
                    </div>

                    <span class="text-[10px] text-neutral-9 leading-tight">
                      {{
                        hasFinalOffer(app)
                          ? 'Taux confirmé suite à la visite du bien'
                          : 'Soumis à confirmation après visite sur place'
                      }}
                    </span>
                  </div>

                  <!-- 2. Avis de valeur / Estimation -->
                  <div
                    class="p-3.5 rounded-xl bg-indigo-1/40 border border-indigo-4/60 flex flex-col justify-between gap-1"
                  >
                    <div class="flex items-center justify-between">
                      <span class="text-[11px] font-semibold text-indigo-11">Estimation du bien</span>
                      @if (getRecommendedPrice(app)) {
                        <span
                          class="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-indigo-3 text-indigo-11"
                        >
                          Avis de valeur
                        </span>
                      }
                    </div>

                    <div class="flex items-baseline gap-1.5 mt-1 flex-wrap">
                      @if (getRecommendedPrice(app); as price) {
                        <span class="text-xl font-black text-indigo-12">
                          {{ price | number: '1.0-0' : 'fr-FR' }} €
                        </span>
                        @if (getAgentPricePerM2(app); as m2) {
                          <span class="text-xs text-indigo-11 font-medium">
                            ({{ m2 | number: '1.0-0' : 'fr-FR' }} €/m²)
                          </span>
                        }
                        @if (getPriceDifferencePercent(app); as diff) {
                          <span
                            class="text-[11px] font-bold px-1.5 py-0.2 rounded"
                            [class]="diff >= 0 ? 'text-jade-11 bg-jade-2' : 'text-amber-11 bg-amber-2'"
                          >
                            {{ diff > 0 ? '+' : '' }}{{ diff }} %
                          </span>
                        }
                      } @else {
                        <span class="text-sm font-semibold text-neutral-10 italic mt-1">
                          Transmis après visite
                        </span>
                      }
                    </div>

                    <span class="text-[10px] text-indigo-10 leading-tight">
                      @if (getRecommendedPrice(app)) {
                        @if (dvfData()?.medianPriceM2; as dvfM2) {
                          Médiane DVF quartier : {{ dvfM2 | number: '1.0-0' : 'fr-FR' }} €/m²
                        } @else {
                          Prix de commercialisation conseillé par l'agent
                        }
                      } @else {
                        Expertise sur place nécessaire pour évaluer le bien
                      }
                    </span>
                  </div>
                </div>

                <!-- OBSERVATION DE L'AGENT (SI DISPONIBLE) -->
                @if (getValuationPresentation(app); as pres) {
                  <div class="p-3 rounded-xl bg-neutral-2 border border-neutral-3 mb-4 flex flex-col gap-1">
                    <div class="flex items-center gap-1.5 text-neutral-10 font-semibold text-[11px]">
                      <mat-icon class="size-3.5 text-[13px]! text-indigo-10">comment</mat-icon>
                      <span>Analyse de l'agent</span>
                    </div>
                    <p class="text-xs text-neutral-11 m-0 line-clamp-2 italic leading-relaxed">
                      « {{ pres }} »
                    </p>
                  </div>
                }

                <!-- SERVICES INCLUS -->
                <div class="flex flex-col gap-1.5 mb-4">
                  <div class="flex items-center justify-between">
                    <span class="text-xs font-semibold text-neutral-11"
                      >Services inclus dans le mandat :</span
                    >
                    <span class="text-[11px] text-neutral-9 font-medium">
                      {{ getServices(app).length }} service{{ getServices(app).length > 1 ? 's' : '' }}
                    </span>
                  </div>
                  <div class="flex flex-wrap gap-1.5">
                    @for (srv of getServices(app); track srv) {
                      <span
                        class="inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-medium bg-neutral-2 text-neutral-11 border border-neutral-4"
                        [matTooltip]="getServiceDescription(srv)"
                      >
                        <mat-icon class="size-3.5 text-[13px]! text-indigo-10">{{
                          getServiceIcon(srv)
                        }}</mat-icon>
                        <span>{{ getServiceLabel(srv) }}</span>
                      </span>
                    }
                    @if (getServices(app).length === 0) {
                      <span class="text-xs text-neutral-9 italic">Aucun service spécifique sélectionné</span>
                    }
                  </div>
                </div>

                <!-- ALERTE ACTION ATTENDUE (SI PRÉSENTE) -->
                @if (getPendingActionNotice(app); as notice) {
                  <div
                    class="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium mb-4 border"
                    [class]="
                      notice.isOwnerAction
                        ? 'bg-amber-2 text-amber-11 border-amber-5'
                        : 'bg-indigo-2 text-indigo-11 border-indigo-4'
                    "
                  >
                    <mat-icon class="size-4 text-base! shrink-0">{{
                      notice.isOwnerAction ? 'notification_important' : 'pending'
                    }}</mat-icon>
                    <span class="flex-1">{{ notice.label }}</span>
                  </div>
                }
              </div>

              <!-- BOUTON D'ACTION (OUVRIR LE TIROIR) -->
              <div class="pt-4 border-t border-neutral-3 mt-auto">
                <button
                  mat-flat-button
                  class="w-full rounded-lg! py-2.5! text-xs! font-semibold! flex items-center justify-center gap-1.5"
                  [class]="app.status === 'accepted' ? 'bg-jade-9 hover:bg-jade-10 text-white' : 'primary'"
                  (click)="$event.stopPropagation(); onSelect(app)"
                  type="button"
                >
                  <span>{{
                    app.status === 'accepted' ? 'Dossier du mandataire' : 'Consulter le dossier'
                  }}</span>
                  <mat-icon class="size-4 text-sm!">arrow_forward</mat-icon>
                </button>
              </div>
            </div>
          } @else {
            <!-- PLACE VACANTE / DISPONIBLE -->
            <div
              class="flex flex-col items-center justify-center text-center p-8 rounded-2xl border-2 border-dashed border-neutral-4 bg-neutral-1/40 min-h-90 gap-4"
            >
              <div
                class="flex size-14 items-center justify-center rounded-2xl bg-neutral-3 text-neutral-9 border border-neutral-4 shadow-2xs"
              >
                <mat-icon class="size-7 text-3xl!">person_add_alt</mat-icon>
              </div>

              <div class="flex flex-col gap-1.5 max-w-sm">
                <span class="text-sm font-bold text-neutral-11 uppercase tracking-wider">
                  Place {{ slot.index + 1 }} libre
                </span>
                <p class="text-xs sm:text-sm text-neutral-10 m-0 leading-relaxed">
                  Un autre agent certifié de votre zone peut encore candidater sur votre bien. La sélection
                  est plafonnée à 5 agents pour garantir la rareté et l'exclusivité.
                </p>
              </div>

              <span
                class="mt-1 inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium bg-neutral-2 text-neutral-10 border border-neutral-4"
              >
                <mat-icon class="size-3.5 text-xs! text-neutral-9">hourglass_empty</mat-icon>
                <span>En attente de candidature</span>
              </span>
            </div>
          }
        }
      </div>
    }

    <!-- 2. VUE DES CANDIDATURES ANNULÉES / RETIRÉES (OU TOUTES) -->
    @if (filterTab() === 'cancelled' || (filterTab() === 'all' && cancelledApplicationsCount() > 0)) {
      @if (filterTab() === 'all') {
        <div class="flex items-center gap-2 pt-6 border-t border-neutral-3">
          <h3 class="text-xs font-bold text-neutral-11 m-0 uppercase tracking-wider">
            Candidatures annulées ou retirées ({{ cancelledApplicationsCount() }})
          </h3>
        </div>
      }

      @if (cancelledApplicationsCount() === 0) {
        <div
          class="flex flex-col items-center justify-center text-center p-8 rounded-2xl border-2 border-dashed border-neutral-4 bg-neutral-1/40 min-h-55 gap-3"
        >
          <mat-icon class="size-8 text-4xl! text-neutral-9">check_circle</mat-icon>
          <span class="text-sm font-bold text-neutral-11">Aucune candidature annulée</span>
          <p class="text-xs text-neutral-10 m-0 max-w-sm">
            Toutes les candidatures reçues sur ce bien sont actuellement actives dans la sélection.
          </p>
        </div>
      } @else {
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          @for (app of cancelledApplications(); track app._id) {
            <div
              class="flex flex-col rounded-2xl border border-neutral-4 bg-white p-5 shadow-xs transition-all hover:border-neutral-5"
            >
              <!-- En-tête : Agent & Badge de statut -->
              <div class="flex items-start justify-between gap-3 pb-4 border-b border-neutral-3">
                <div class="flex items-center gap-3 min-w-0">
                  <button
                    type="button"
                    (click)="openAgentProfileModal(app, $event)"
                    class="relative size-12 shrink-0 rounded-xl overflow-hidden bg-neutral-3 border border-neutral-4 flex items-center justify-center font-bold text-sm text-neutral-11 shadow-2xs cursor-pointer hover:ring-2 hover:ring-indigo-7 transition-all p-0"
                    matTooltip="Voir le profil de l'agent"
                  >
                    @if (getAgentAvatar(app); as avatar) {
                      <img [src]="avatar" [alt]="getAgentName(app)" class="h-full w-full object-cover" />
                    } @else {
                      <span>{{ getAgentInitials(app) }}</span>
                    }
                  </button>

                  <div class="flex flex-col min-w-0">
                    <div class="flex items-center gap-1.5">
                      <button
                        type="button"
                        (click)="openAgentProfileModal(app, $event)"
                        class="text-left p-0 border-0 bg-transparent font-bold text-sm text-neutral-12 truncate hover:text-indigo-11 cursor-pointer transition-colors"
                      >
                        {{ getAgentName(app) }}
                      </button>
                      <mat-icon
                        class="size-4 text-base! text-indigo-10 shrink-0"
                        matTooltip="Agent vérifié par ETXE"
                        >verified</mat-icon
                      >
                    </div>
                    <span class="text-xs text-neutral-10 truncate font-medium">
                      {{ getAgentNetwork(app) }}
                    </span>
                    @if (getAgentCity(app); as city) {
                      <span class="text-[11px] text-neutral-9 truncate flex items-center gap-1 mt-0.5">
                        <mat-icon class="size-3 text-[11px]!">place</mat-icon>
                        <span>{{ city }}</span>
                      </span>
                    }
                  </div>
                </div>

                @let cfg = getStatusConfig(app.status);
                <span
                  class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold shrink-0 border"
                  [class]="cfg.badgeClass"
                  [matTooltip]="cfg.hint"
                >
                  <mat-icon class="size-3.5 text-sm!">{{ cfg.icon }}</mat-icon>
                  <span>{{ cfg.label }}</span>
                </span>
              </div>

              <!-- Corps : Historique & Informations -->
              <div class="py-4 flex flex-col gap-3 flex-1">
                <div class="flex items-center justify-between text-xs text-neutral-10">
                  <span>Date de candidature</span>
                  <span class="font-medium text-neutral-12">
                    {{ app.createdAt | luxonDate: 'dd/LL/yyyy' }}
                  </span>
                </div>

                @if (app.updatedAt && app.updatedAt !== app.createdAt) {
                  <div class="flex items-center justify-between text-xs text-neutral-10">
                    <span>Date de retrait</span>
                    <span class="font-medium text-neutral-12">
                      {{ app.updatedAt | luxonDate: 'dd/LL/yyyy' }}
                    </span>
                  </div>
                }

                @if (getCommissionRate(app); as rate) {
                  <div
                    class="flex items-center justify-between text-xs text-neutral-10 pt-2 border-t border-neutral-3"
                  >
                    <span>Commission proposée</span>
                    <span class="font-bold text-neutral-12">{{ rate }} % TTC</span>
                  </div>
                }

                <!-- Encadré informatif sur la libération de place -->
                <div
                  class="mt-auto p-3 rounded-xl bg-neutral-2 border border-neutral-3 flex items-start gap-2.5"
                >
                  <mat-icon class="size-4 text-base! text-neutral-9 shrink-0 mt-0.5">info</mat-icon>
                  <p class="text-xs text-neutral-10 m-0 leading-relaxed">
                    @if (app.status === 'cancelled') {
                      L'agent s'est retiré de sa candidature. La place a été automatiquement libérée pour
                      permettre à un autre agent de candidater.
                    } @else if (app.status === 'rejected') {
                      Vous avez décliné cette candidature. La place reste disponible pour d'autres agents.
                    } @else {
                      Le délai de réponse a expiré sans confirmation.
                    }
                  </p>
                </div>
              </div>

              <!-- Actions -->
              <div class="pt-3 border-t border-neutral-3 flex items-center gap-2">
                @if (app.discussion) {
                  <button
                    mat-stroked-button
                    type="button"
                    (click)="openDiscussion(app, $event)"
                    class="flex-1 py-2! text-xs font-semibold flex items-center justify-center gap-1.5 border-neutral-4!"
                  >
                    <mat-icon class="size-4 text-base! text-neutral-10">forum</mat-icon>
                    <span>Discussion</span>
                  </button>
                }
                <button
                  mat-stroked-button
                  type="button"
                  (click)="onSelect(app)"
                  class="flex-1 py-2! text-xs font-semibold flex items-center justify-center gap-1.5 border-neutral-4!"
                >
                  <span>Consulter</span>
                  <mat-icon class="size-4 text-base! text-neutral-10">visibility</mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
      }
    }
  }
</div>
